import { CollectionCard } from '~/components';
import { useCollectionsControllerGetAllCollectionsInfinite } from '~/lib/api';
import { withInfiniteQueryDefaults } from '~/lib/infinite-query';

export function HomePackGridSection() {
  const minimumFeatured = 1;

  const { data: packs } = useCollectionsControllerGetAllCollectionsInfinite(
    { minimumFeatured },
    {
      query: withInfiniteQueryDefaults({}),
    },
  );

  return (
    <>
      <h1 className="text-white text-2xl font-bold font-quicksand pb-4">{'Packs'}</h1>

      <div className="grid grid-cols-2 gap-3 mb-12">
        {packs?.pages
          .flatMap((page) => page.data.data)
          .map((pack) => (
            <CollectionCard
              key={pack.id}
              brandName={pack.brandName}
              id={pack.id}
              imagePosition={pack.imagePosition}
              imageSrc={pack.image}
              label={pack.totalSupply}
              rarity={pack.rarity}
              title={pack.name}
            />
          ))}
      </div>
    </>
  );
}
